export default __webpack_public_path__ + "static/itops-57ae092d6bf2f9575501df6a95e93da0.png";